module.exports = __webpack_public_path__ + "img/map-search-icon.efc2fbe0.svg";